import React, { Component } from 'react';
import axios from "axios"
import moment from "moment"
import UploadPdfZone from "./UploadPdfZone"
export default class UploadEntree extends Component {
  constructor(props) {
    super(props);
    this.loadBien = this.loadBien.bind(this)
    this.state = {
      pdf: undefined,
      derniere_entree: {},
      bien: {}
    };
    this.loadBien()
  }
  loadBien(){
    axios.post("/api/v1/experts/app/demandesManuels/info",{id: this.props.bien}).then((data)=>{
      data = data.data
      this.setState(data)
    })
  }
  render() {
    return (
      <div>
        {(this.state.pdf !== undefined && this.state.pdf !== null) ? (
            <div>
              <p className="green-text">Nous possédons déjà
              l'état des lieux d'entrée fait
               en {moment(this.state.derniere_entree.created_at).format("MM/YYYY")}
              </p>
              <p>Vous en avez un plus récent ? uploader le ici</p>
            </div>
          ) : (
              <p>Nous ne possédons pas d'ancien état des lieux, veuillez en uploader un svp</p>
          )}
          <UploadPdfZone bien={this.props.bien} />
      </div>
    );
  }
}
